import React from 'react';
import { motion } from 'framer-motion';
import { packItems, formatArs } from '../data/content';
const totalValue = packItems.reduce((sum, item) => sum + item.value, 0);
export function ValueStack() {
  return <section className="bg-linen py-16 sm:py-24" aria-labelledby="pack-title" data-id="element-187" data-mp="1q94pq5ohrf1p">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-5 lg:grid-cols-[0.9fr_1fr] lg:gap-16" data-id="element-188" data-mp="1u9ohsuu7jsgz">
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.55
      }} className="overflow-hidden rounded-[2rem] border-8 border-white shadow-soft" data-id="element-189" data-mp="2hz0sjz56o8le">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/4ec493ac-4c1d-48d4-9bff-cb8ad05cd4ff.jpg" alt="Manual Maestro Amigurumi mostrado en libro impreso, tablet y celular" className="h-full w-full object-cover" data-id="element-190" data-mp="2d7hlw0gki8fy" />
        </motion.div>

        <div data-id="element-191" data-mp="1tf3hc4kqup4q">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-terracotta" data-id="element-192" data-mp="1tetqkervkdxz">
            El pack completo
          </span>
          <h2 id="pack-title" className="mt-4 font-display text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-193" data-mp="1ohuwtxc4i90b">
            Al inscribirte hoy, te llevás todo esto
          </h2>

          <ul className="mt-8 space-y-3" data-id="element-194" data-mp="1ydeo26fqsjiq">
            {packItems.map((item, index) => <motion.li key={item.name} initial={{
            opacity: 0,
            x: 16
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            amount: 0.4
          }} transition={{
            duration: 0.4,
            delay: index * 0.07
          }} className="flex items-center gap-4 rounded-2xl border border-wool bg-white p-4 sm:p-5" data-id="element-195" data-mp="2c5be84xuojch" data-mpi={index}>
                <span className="text-2xl" aria-hidden="true" data-id="element-196" data-mp="rr2hx30xen04">
                  {item.label}
                </span>
                <div className="min-w-0 flex-1" data-id="element-197" data-mp="msheyvuahp7z">
                  <p className="font-display text-base font-black leading-snug text-ink sm:text-lg" data-id="element-198" data-mp="2mtfoasj2t041">
                    {item.name}
                  </p>
                  <p className="text-sm text-muted" data-id="element-199" data-mp="2rsiq843req7s">{item.detail}</p>
                </div>
                <p className="shrink-0 text-right text-sm font-bold text-muted" data-id="element-200" data-mp="2vsatc1adw45r">
                  Valor
                  <span className="block text-base text-ink" data-id="element-201" data-mp="30u8hn9xn5p5k">{formatArs(item.value)}</span>
                </p>
              </motion.li>)}
          </ul>

          <div className="mt-6 flex items-center justify-between rounded-2xl bg-ink px-6 py-5 text-cream" data-id="element-202" data-mp="3aql9e29mlsxo">
            <p className="font-display text-lg font-black uppercase tracking-wide" data-id="element-203" data-mp="3fhl5x6eu28zn">Valor total</p>
            <p className="font-display text-2xl font-black" data-id="element-204" data-mp="3jjoki3wsttp5">{formatArs(totalValue)} ARS</p>
          </div>
        </div>
      </div>
    </section>;
}